<template>
    <card class="card">
        <div class="card-body">
            <h2 class="pt-0 mt-0">
                <i class="fas fa-file-invoice text-primary"></i> {{$t('request.titleedit')}}
            </h2>
            <hr />
            <div>
                <form @submit.prevent id="userEdit">
                    <div class="row mt-4">
                        <div class="col-md-6">
                            <fg-input
                                type="text"
                                :label="$t('request.code')"
                                name="code"
                                placeholder
                                v-model="form.request_code"
                            ></fg-input>
                        </div>
                        <div class="col-md-6">
                            <fg-input
                                type="text"
                                :label="$t('request.repairid')"
                                name="repair_id"
                                placeholder
                                v-model="form.repair_id"
                            ></fg-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <label>{{$t('request.asf')}}</label>
                            <multiselect
                                v-model="form.asf"
                                :options="asfs"
                                :custom-label="asfLabel"
                                :placeholder="$t('reques.text.selectone')"
                                label="name"
                                track-by="id"
                                disabled
                            ></multiselect>
                        </div>
                        <div class="col-md-6">
                            <label for>{{$t('request.status')}}</label>
                            <select
                                class="form-control"
                                v-model="form.status"
                                :disabled="saved_status == 'completed'"
                            >
                                <option value>{{$t('request.text.select')}}</option>
                                <option value="new">{{$t('request.option.new')}}</option>
                                <option value="in_analysis">{{$t('request.option.in_analysis')}}</option>
                                <option value="analysis_completed">{{$t('request.option.analysis_completed')}}</option>
                                <option value="in transit" v-if="canedit()" :disabled="statusIsDisabled()">{{$t('request.option.intransit')}}</option>
                                <option value="completed" :disabled="statusIsDisabled()">{{$t('request.option.completed')}}</option>
                                <option value="canceled" :disabled="statusIsDisabled()">{{$t('request.option.canceled')}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row mt-4" v-if="form.status == 'completed'">
                        <div class="col-md-6">
                            <fg-input
                                type="text"
                                :label="$t('request.invoicenumber')"
                                name="invoice_number"
                                placeholder
                                v-model="form.invoice_number"
                            ></fg-input>
                        </div>
                    </div>
                    <!--div class="row mt-2" v-if="form.status == 'completed'">
                        <div class="col-md-6">
                            <label for="canna">
                                <input type="checkbox" id="canna" @click="tog_cann" />
                                Cannabalization
                            </label>
                        </div>
                    </div>
                    <div class="row mt-2" v-if="form.status == 'completed' && cannabalization">
                        <div class="col-md-6">
                            <fg-input
                                type="text"
                                label="Printer Serial Number"
                                name="serial_number"
                                placeholder
                                v-model="form.serial_number"
                            ></fg-input>
                        </div>
                        <div class="col-md-6">
                            <fg-input
                                type="text"
                                label="Printer Invoice Number"
                                name="printer_invoice"
                                placeholder
                                v-model="form.printer_invoice"
                            ></fg-input>
                        </div>
                    </div-->
                    <div class="row mt-4">
                        <div class="col-md-12">
                            <ShoppingCart
                                :showButtons="false"
                                :Options="false"
                                :showRequestButton="false"
                            />
                            <button
                                v-if="canedit && form.status == 'in transit'"
                                class="btn btn-lg btn-primary px-4"
                                v-b-modal.shoppingCart
                            >{{$t('request.changeparts')}}</button>
                        </div>
                    </div>
                    <div class="row mt-2 mb-2">
                        <div class="col-md-12">
                            <label for>{{$t('request.notes')}}</label>
                            <textarea
                                class="form-control"
                                v-model="form.note"
                                name="note"
                                cols="30"
                                rows="5"
                            ></textarea>
                        </div>
                    </div>
                    <div class="text-left">
                        <p-button type="primary" @click.native.prevent="update">{{$t('request.button.save')}}</p-button>
                    </div>
                    <div class="clearfix"></div>
                </form>
            </div>
        </div>
        <b-modal id="shoppingCart" ref="shoppingCart" size="xl" hide-footer title="Request Parts">
            <RequestParts :showAsfSelection="false" :showButtons="true" :showReqButton="false"></RequestParts>
        </b-modal>
    </card>
</template>
<script>
import { mapState } from "vuex";
import ShoppingCart from "@/pages/parts/ShoppingCart.vue";
import RequestParts from "@/pages/parts/RequestParts.vue";

export default {
  components: {
    ShoppingCart,
    RequestParts
  },
  data() {
    return {
      cannabalization: false,
      saved_status: ""
    };
  },
  computed: {
    ...mapState("requests", {
      request: "request"
    }),
    ...mapState("cart", {
      cart: "all",
      inCart: "inCart"
    }),
    ...mapState("asfs", {
      asfs: "all"
    }),
    form() {
      return this.request;
    }
  },
  created() {
    this.$store.dispatch("requests/get", this.$route.params.id).then(resp => {
      let arr = [];
      this.request.items.forEach(item => {
        arr.push({
          name: item.part.name,
          part_id: item.part_id,
          sku: item.part.sku,
          quantity: item.quantity,
          in_warranty: item.in_warranty,
          inventory_type_id: item.inventory_type_id,
          from_stock: 0,
          unit_price: item.part.price,
          price: !item.in_warranty ? item.part.price * item.quantity : 0
        });
      });
      this.$store.commit("cart/setCart", arr);
      this.$store.dispatch("cart/getAllParts", "requests");
      if (this.canedit()) {
        this.$store.dispatch("asfs/getAllAsfs");
      }
      this.saved_status = this.request.status;
    });
  },
  methods: {
    statusIsDisabled() {
      if (this.request.status_history === null || !this.request.status_history.includes("analysis_completed")) {
        return true;
      }

      return false;
    },
    asfLabel({ name, vat }) {
      return `${name} — ${vat}`;
    },
    canedit() {
      return this.$store.getters["auth/getSessionRoles"].includes("admin");
    },
    tog_cann() {
      this.cannabalization = !this.cannabalization;
    },
    update() {
      this.form.asf_id = this.form.asf.id;
      this.form.items = this.inCart;
      this.$store
        .dispatch("requests/edit", this.form)
        .then(response => {
          this.request = this.form;
          this.$notify({
            type: "success",
            message: this.$t('request.message.successupdate')
          });
        })
        .catch(error => {
          let msg = "";
          if (error.response.data) {
            msg = error.response.data.errors[0].detail;
          } else {
            msg = error.response.message;
          }
          this.$notify({
            type: "danger",
            horizontalAlign: "center",
            message: msg
          });
        });
    }
  }
};
</script>
<style>
</style>
